import React, { FC } from 'react';
import {
  Title,
  FormWrapper,
  Header,
  CloseModalButton,
  LeftSideBarWrapper,
  Modal,
  MobileHeading,
  PrevStepButton,
  InnerScroller,
} from '@common/components/BookingForms';

type TableConfigurationWizardProps = {
  handleClose: () => void;
  isModalOpen: boolean;
  restaurantName?: string;
  children: React.ReactNode;
};

export const TableConfigurationWizard: FC<TableConfigurationWizardProps> = ({
  handleClose,
  isModalOpen,
  restaurantName,
  children,
}) => {
  return (
    <Modal isVisible={isModalOpen}>
      <Header>
        <PrevStepButton onClick={handleClose} />
        <MobileHeading>{restaurantName}</MobileHeading>
        <CloseModalButton onClick={handleClose} />
      </Header>
      <InnerScroller>
        <FormWrapper>
          <Title titleId="tables.bookTable" />
          <LeftSideBarWrapper>{children}</LeftSideBarWrapper>
        </FormWrapper>
      </InnerScroller>
    </Modal>
  );
};

export default TableConfigurationWizard;
